var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy243(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 49.6,
    r: 32.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.6,63.5c0-1.6-0.9-2.9-2.2-3.6v-3h-3.5v3c-1.3,0.7-2.2,2-2.2,3.6c0,1.6,0.9,2.9,2.2,3.6v3h3.5v-3 C52.7,66.4,53.6,65.1,53.6,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M38.4,38.2c-1.1-1.1-2.7-1.4-4.1-1l-2.1-2.1l-2.5,2.5l2.1,2.1c-0.5,1.4-0.1,3,1,4.1c1.1,1.1,2.7,1.4,4.1,1 l2.1,2.1l2.5-2.5l-2.1-2.1C39.8,40.9,39.5,39.3,38.4,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M66.4,43.8c1.1-1.1,1.4-2.7,1-4.1l2.1-2.1L67,35.1l-2.1,2.1c-1.4-0.5-3-0.1-4.1,1c-1.1,1.1-1.4,2.7-1,4.1 l-2.1,2.1l2.5,2.5l2.1-2.1C63.8,45.3,65.3,44.9,66.4,43.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy243);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-243.e0ed94a70ad3b84c84f16a0d56beea52.svg";
export { ForwardRef as ReactComponent };